<template>
	<div class="profileWrapper contentPage">
		<div class="tabBlock">
			<div>

				<v-tabs
						touchless
						class="tabList"
						backgrundColor="#2B2B37"
						v-model="tab"
						center-active
						height="40"
						show-arrows
						@change="handleTabChange"
				>

					<v-tabs-slider color="#4CAF50"></v-tabs-slider>

<!--					<v-tab-->
<!--							v-for="item in getTabList"-->
<!--							:disabled="item.disabled"-->
<!--							:key="item.tab"-->
<!--							:href="item.href"-->
<!--							class="tab"-->
<!--							:class="{'errorTab': item.error}"-->
<!--					>-->

					<v-tab
							v-for="item in getTabList.filter(tab => !tab.hidden)"
							:key="item.tab"
							:href="item.href"
							class="tab"
							:class="{'errorTab': item.error}"
					>
						<div v-if="item.icon" class="icon"><svg-sprite :icon-id="item.icon" width="20" height="20"></svg-sprite></div>
						<div class="text">{{ item.text }}</div>
					</v-tab>

				</v-tabs>

				<v-tabs-items v-model="tab">
					<v-tab-item @touchstart.stop @touchmove.stop value="tabUserHome">
						<user-tab-home
								:key="tabKeys['tabUserHome']"
								@updateUser="onUser"
								@updateViewDuties="onViewDuties"
								@updateCalendarEventIconBtn="onCalendarEventIconBtn"
						/>
					</v-tab-item>

					<v-tab-item @touchstart.stop @touchmove.stop value="tabUserInformation">
						<user-tab-information :key="tabKeys['tabUserInformation']" />
					</v-tab-item>

					<v-tab-item @touchstart.stop @touchmove.stop value="tabUserBonusСharge">
						<user-tab-bonus-charge :key="tabKeys['tabUserBonusСharge']" :user="user" />
					</v-tab-item>

					<v-tab-item @touchstart.stop @touchmove.stop value="tabSalaryHistory">
						<user-tab-salary-history :key="tabKeys['tabSalaryHistory']" :user="user" />
					</v-tab-item>

					<v-tab-item @touchstart.stop @touchmove.stop value="tabVacation">
						<div :key="tabKeys['tabVacation']">tab tabVacation</div>
					</v-tab-item>

					<v-tab-item @touchstart.stop @touchmove.stop value="tabStatementsItems">
						<user-tab-statements :key="tabKeys['tabStatementsItems']" :user="user" />
					</v-tab-item>

          <v-tab-item @touchstart.stop @touchmove.stop value="tabUserLogs">
            <user-tab-logs :key="tabKeys['tabUserLogs']" :user="user" ></user-tab-logs>
          </v-tab-item>

				</v-tabs-items>

			</div>
		</div>

		<account-day-chat
				v-if="isAccountDayChat"
				:employee-id="userId"
				:active-item="activeItem"
				@updateClose="onAccountDayChatClose"
				@updateSave="onAccountDayChatSave"
		></account-day-chat>
		<view-duties
				v-if="isViewDuties"
				:duties="duties"
				:department="department"
				@updateClosePopup="onCloseViewDuties"
		></view-duties>
	</div>
</template>

<script>

import { defineAsyncComponent } from "vue";
import UserTabHome from "@/pages/UserProfile/Tabs/UserTabHome.vue";
import { mapActions, mapGetters } from "vuex";
import { PERMISSIONS } from "@/constants/constants";
import { getPermissionsMod } from "@/helper/getPermissionsMod";

export default {
	name: "UserProfile",
	components: {
		UserTabHome,

		ViewDuties: defineAsyncComponent(() => import("@/pages/Account/Dialogs/ViewDuties.vue")),
		UserTabInformation: defineAsyncComponent(() => import("@/pages/UserProfile/Tabs/UserTabInformation.vue")),
		UserTabBonusCharge: defineAsyncComponent(() => import("@/pages/UserProfile/Tabs/UserTabBonusCharge.vue")),
		UserTabStatements: defineAsyncComponent(() => import("@/pages/UserProfile/Tabs/UserTabStatements.vue")),
		UserTabSalaryHistory: defineAsyncComponent(() => import("@/pages/UserProfile/Tabs/UserTabSalaryHistory.vue")),
		AccountDayChat: defineAsyncComponent(() => import("@/shared/AccountDayChat/AccountDayChat.vue")),
		UserTabLogs: defineAsyncComponent(() => import("@/pages/UserProfile/Tabs/UserTabLogs")),

	},

	computed: {
		...mapGetters([
			// 'permissions',
			'permissionsDefault',
		]),
		getTabList() {
			// const permissions = this.permissions || {};
			const list = this.permissionsDefault;
			const user_my_info = [ PERMISSIONS.ACCOUNT, PERMISSIONS.ACCOUNT_USERS, PERMISSIONS.ACCOUNT_MY_INFO ];
			const user_bonus_charge = [ PERMISSIONS.ACCOUNT, PERMISSIONS.ACCOUNT_USERS, PERMISSIONS.ACCOUNT_USER_BONUS_CHARGE ];
			const user_salary_history = [ PERMISSIONS.ACCOUNT, PERMISSIONS.ACCOUNT_USERS, PERMISSIONS.ACCOUNT_USER_SALARY_HISTORY ];
			const user_st_ts = [ PERMISSIONS.ACCOUNT, PERMISSIONS.ACCOUNT_USERS, PERMISSIONS.ACCOUNT_ST_TS ];
			// ACCOUNT_ST_TS
			// ACCOUNT_MY_INFO
			// ACCOUNT_USER_COMMENTS
			// ACCOUNT_USER_SALARY_HISTORY
			// ACCOUNT_USER_VACATION
			// ACCOUNT_USER_EVENTS
			// ACCOUNT_USER_GEO
			return [
				{
					text: 'User',
					tab: 'User',
					href: '#tabUserHome',
					icon: 'icon-user',
					hidden: false
				},
				{
					text: 'User information',
					tab: 'User information',
					href: '#tabUserInformation',
					icon: 'setting',
					hidden: !getPermissionsMod({ list, path: user_my_info }),
				},
				{
					text: 'Bonus/Сharge',
					tab: 'BonusСharge',
					href: '#tabUserBonusСharge',
					icon: 'icon-plus',
					hidden: !getPermissionsMod({ list, path: user_bonus_charge }),
				},
				{
					text: 'Salary History',
					tab: 'SalaryHistory',
					href: '#tabSalaryHistory',
					icon: 'dollar-sign',
					hidden: !getPermissionsMod({ list, path: user_salary_history }),
				},

				// {
				// 	text: 'Vacation',
				// 	tab: 'Vacation',
				// 	href: '#tabVacation',
				// 	icon: 'sun',
				// hidden: false
				// },
				{
					text: 'St-ts',
					tab: 'StatementsItems',
					href: '#tabStatementsItems',
					icon: 'dollar-sign',
					hidden: !getPermissionsMod({ list, path: user_st_ts }),
				},
				{
					text: 'Logs',
					tab: 'tabUserLogs',
					href: '#tabUserLogs',
					icon: 'reset',
					hidden: !getPermissionsMod({ list, path: user_st_ts }),
				},
			];
		},
	},
	data() {
		return {
			userId: null,
			user: null,
			tab: "tabUserHome", // Устанавливаем начальный активный таб
			tabKeys: {
				tabUserHome: 0,
				tabUserInformation: 0,
				tabUserBonusСharge: 0,
				tabSalaryHistory: 0,
				tabVacation: 0,
				tabStatementsItems: 0,
			},

			activeItem: null,
			isAccountDayChat: false,
			dateCalendar: null,
			employee_id: null,
			isViewDuties: false,
			duties: null,
			department: null,
		};
	},
	methods: {
		...mapActions([
			'getAccountDayChatNote',
			'getUserUpdateCalendar',
			'getAccountDaySick',
		]),

		onCloseViewDuties() {
			this.isViewDuties = false;
		},
		onViewDuties({ duties, department }) {
			this.duties = duties;
			this.department = department;
			this.isViewDuties = true;
		},
		handleTabChange(newTab) {
			// Увеличиваем ключ только для открываемого таба
			if (newTab === "tabUserBonusСharge" || newTab === "tabStatementsItems" || newTab === "tabUserHome") {
				this.$set(this.tabKeys, newTab, this.tabKeys[newTab] + 1);
			}
		},
		onUser(atrs) {
			this.user = atrs;
		},

		async onCalendarEventIconBtn(args) {
			const { key, item, employee_id, date } = args;
			console.log('%c [  args  ] ', 'color:#bada55', typeof args, args );
			this.activeItem = item;
			this.employee_id = employee_id;
			this.dateCalendar = date;

			if (key === 'comment') {
				this.isAccountDayChat = true;
			}
			if (key === 'sick') {

				const { date } = item;
				const id = this.employee_id;
				await this.getAccountDaySick({ id, date });
				this.updateCalendar();
			}
		},
		onAccountDayChatClose() {
			this.isAccountDayChat = false;
		},
		async onAccountDayChatSave(args) {
			this.isAccountDayChat = false;

			const argsMod = { ...args, employee_id: this.employee_id };
			await this.getAccountDayChatNote(argsMod);
			const date = this.dateCalendar;
			const id = this.employee_id;
			const type = 'comments';
			await this.getUserUpdateCalendar({ id, date, type });
		},
		async updateCalendar() {
			const date = this.dateCalendar;
			const id = this.employee_id;
			const type = 'date';
			await this.getUserUpdateCalendar({ id, date, type });
		}
	}
};
</script>

<style scoped lang="scss">
	@import "UserProfile";
</style>
